import { Icon, Menu } from "materia"
import { useTranslation } from "react-i18next"
import s from "./DirectMenu.module.scss"

type DirectMenuProps = {
  /** The other person's display name, for the trigger's label. */
  name: string
  isMuted: boolean
  onToggleMute: () => void
}

/** A direct conversation's header menu: only the user's own Mute. */
export function DirectMenu({ name, isMuted, onToggleMute }: DirectMenuProps) {
  const { t } = useTranslation()

  return (
    <Menu>
      <Menu.Trigger asChild={true}>
        <button
          className={s.menu__trigger}
          type="button"
          aria-label={String(t("chat.CONVERSATION_MENU_ARIA", { name }))}
        >
          <Icon icon="Dots" />
        </button>
      </Menu.Trigger>

      <Menu.Content anchor="bottom end" className={s.menu__content}>
        <Menu.Item
          as="button"
          type="button"
          className={s.menu__item}
          onClick={onToggleMute}
        >
          {t(isMuted ? "chat.UNMUTE_CONVERSATION" : "chat.MUTE_CONVERSATION")}
        </Menu.Item>
      </Menu.Content>
    </Menu>
  )
}
